module.exports = __webpack_public_path__ + "img/logo.e678d9b5.svg";